import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Typography, Breadcrumbs, Link, makeStyles } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box } from "@material-ui/core";
import homeImg from "../assets/icons/home_bread_crump.png";
import folderImg from "../assets/icons/folder_bread_crump.png";
import formNameImg from "../assets/icons/form_name_bread_crump.png";
import { project_url} from "../constants/Data";

const useStyles = makeStyles(() => ({
  text: {
    color: "#0D47A1",
  },
  logo: {
    textAlign: "left",
    height: "20px",
    paddingRight: 10,
    paddingBottom: 2,
  },
  box: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

const MenuHeader = ({ breadcrumbName }) => {
  const classes = useStyles();

  return (
    <div>
      <Breadcrumbs
        className={classes.text}
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link className={classes.box} to="/" component={RouterLink}>
          <img src={homeImg} className={classes.logo} />
          <Typography variant="h3" className={classes.text}>
            Home
          </Typography>
        </Link>
        {breadcrumbName && (
          <Link className={classes.box} to={ project_url + "/forms" } component={RouterLink}>
            <img src={folderImg} className={classes.logo} />
            <Typography variant="h3" className={classes.text}>
              Home
            </Typography>
          </Link>
        )}
        {breadcrumbName && (
          <Box className={classes.box}>
            <img src={formNameImg} className={classes.logo} />
            <Typography variant="h3" className={classes.text}>
              {breadcrumbName}
            </Typography>
          </Box>
        )}
      </Breadcrumbs>
    </div>
  );
};

export default MenuHeader;
